import { CALL_PREFIX } from 'app/models/ui/call/constants';

const getCallState = state => state.getIn([CALL_PREFIX]);

const getter = prop => state => getCallState(state).get(prop);

export const getTab                 = getter('tab');
export const getNavigationError     = getter('navigationError');

export const isInContentVideosPresent =
  state => getCallState(state).inContentVideosPresent > 0;
export const isInContentVideosVisible =
  state => getCallState(state).inContentVideosVisible > 0;
